import React from 'react';
import { FormControl, FormLabel, Text, VStack, Textarea } from "@chakra-ui/react";
import { FormikProps } from 'formik/dist/types';
import objectPath from 'object-path';

export interface FormikTextareaProps {
  valueType?: string | number;
  label?: string;
  name: string;
  formik: FormikProps<any>;
  value?: string | number;
}

export const FormikTextarea = (props: FormikTextareaProps): JSX.Element => {
  const { label, name, formik, valueType, value } = props;

  return (
    <FormControl>
      {label && <FormLabel fontSize={'sm'}>{label}</FormLabel>}
      <VStack alignItems={'flex-start'}>
        <Textarea
          isInvalid={!!objectPath.get(formik.errors, name)}
          name={name}
          value={value ? value : formik.values[name]}
          onChange={e => {
            const value = valueType === 'number' ? parseInt(e.target.value) : e.target.value;
            formik.setFieldValue(name, value);
          }}
        />

        {!!objectPath.get(formik.errors, name) && (
          <Text color={'red.500'}>{objectPath.get(formik.errors, name)}</Text>
        )}
      </VStack>
    </FormControl>
  );
};
